import React from 'react';
/** Returns an SVG `<defs />` element defining a crosshatch with the provided ID */
export function Crosshatch(_a) {
    var id = _a.id, color = _a.color, _b = _a.size, size = _b === void 0 ? 4 : _b, _c = _a.strokeWidth, strokeWidth = _c === void 0 ? 1 : _c;
    return (React.createElement("defs", null,
        React.createElement("pattern", { id: id, width: size, height: size, patternTransform: "rotate(45)", patternUnits: "userSpaceOnUse" },
            React.createElement("line", { stroke: color, strokeWidth: strokeWidth, x1: "0", y1: "0", x2: "0", y2: size }))));
}
//# sourceMappingURL=Crosshatch.js.map